import VueObserveVisibility from 'vue-observe-visibility';

export default defineNuxtPlugin({
  name: 'observeVisibility',
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.use(VueObserveVisibility);
  },
});
